import { Box } from '@mui/material'
import { CommentEmptyState } from '@omnea-app/fe-requests/CommentEmptyState'

type EmptyMentionListProps = {
  showResolved: boolean
}

export const EmptyMentionList = ({ showResolved }: EmptyMentionListProps) => {
  return (
    <Box
      sx={{
        bgcolor: 'bg.surface.default',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'border.subtle',
        p: 3,
      }}
    >
      <CommentEmptyState
        commentSource={`dashboard-mentions-${showResolved ? 'resolved' : 'unresolved'}`}
        commentsVisibility="internal"
      />
    </Box>
  )
}
